import React from 'react'

import Layout from '../../components/Layout'
import MemberRoll from '../../components/MemberRoll'

export default class MemberIndexPage extends React.Component {
  render() {
    return (
      <Layout>
        <div
          className="full-width-image-container margin-top-0"
          style={{
            backgroundImage: `url('/img/blog-index.jpg')`,
          }}
        >
          <h1
            className="has-text-weight-bold is-size-1"
            style={{
              color: 'white',
              padding: '1rem',
            }}
          >
            メンバー紹介
          </h1>
        </div>
        <section className="section">
          <div className="container">
            <div className="content">
              <MemberRoll />
            </div>
          </div>
        </section>
      </Layout>
    )
  }
}
